"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IS_ASSISTANT_ALLOWED = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
exports.IS_ASSISTANT_ALLOWED = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query isAssistantAllowed {\n    isAssistantAllowed\n  }\n"], ["\n  query isAssistantAllowed {\n    isAssistantAllowed\n  }\n"])));
var templateObject_1;
